// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (alarmcodes-edit e alarmcodes-list)

import { Injectable } from '@angular/core';
import { Alarmcodes } from './alarmcodes.model';
import { Subject } from 'rxjs';

@Injectable()
export class AlarmcodesService {
  private alarmcodes: Alarmcodes[] = [];
  alarmcodesChanged = new Subject<Alarmcodes[]>();
  alarmcodesEditMode = new Subject<number>();

  constructor(
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editAlarmcodes(alarmcodesId: number) {
    this.alarmcodesEditMode.next(alarmcodesId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setAlarmcodes(alarmcodes: Alarmcodes[]) {
    if (alarmcodes !== null) {
      this.alarmcodes = alarmcodes;
      this.alarmcodesChanged.next(this.alarmcodes.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getAlarmcodesByIndex(id: number) {
    return this.alarmcodes.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getAlarmcodes() {
    return this.alarmcodes;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addAlarmcodes(alarmcodes: Alarmcodes) {
    alarmcodes.id = this.alarmcodes.length;
    this.alarmcodes.push(alarmcodes);
    this.alarmcodesChanged.next(this.alarmcodes.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateAlarmcodes(index: number, alarmcodes: Alarmcodes) {
    this.alarmcodes[index] = alarmcodes;
    this.alarmcodesChanged.next(this.alarmcodes.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteAlarmcodes(id) {
    var elementPos = this.alarmcodes.map(function (x) { return x.id; }).indexOf(id);
    this.alarmcodes.splice(elementPos, 1);
    this.alarmcodesChanged.next(this.alarmcodes.slice());
  }
}
